import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const STEPS = [
  { emoji: "👥", title: "Invités", text: "Commencez par ajouter vos premiers invités.", to: "/app/guests" },
  { emoji: "💌", title: "Invitations", text: "Préparez vos invitations et suivez les réponses.", to: "/app/invitations" },
  { emoji: "🍽️", title: "Plan de table", text: "Organisez vos tables quand vous le souhaitez.", to: "/app/seating" },
  { emoji: "💰", title: "Budget", text: "Gardez vos dépenses sous contrôle.", to: "/app/budget" },
  { emoji: "✨", title: "Site de mariage", text: "Créez votre site et partagez les informations avec vos invités.", to: "/app/website" },
];

export const openGuidedTour = () => window.dispatchEvent(new Event("notreoui:open-tour"));

export default function GuidedTour() {
  const { user, loadMe } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);

  // New accounts only: auto-propose on first use. Existing accounts (no tour_pending) never auto-trigger.
  useEffect(() => {
    if (user && user.tour_pending && !user.tour_completed_at) setOpen(true);
  }, [user]);

  useEffect(() => {
    const h = () => { setI(0); setOpen(true); };
    window.addEventListener("notreoui:open-tour", h);
    return () => window.removeEventListener("notreoui:open-tour", h);
  }, []);

  const finish = async () => {
    setOpen(false); setI(0);
    try { await api.post("/auth/tour/complete"); await loadMe(); } catch {}
  };

  if (!open) return null;
  const s = STEPS[i];
  const last = i === STEPS.length - 1;
  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-4" data-testid="guided-tour">
      <div className="absolute inset-0 bg-black/40" onClick={finish} />
      <div className="relative card-lux w-full max-w-md p-6 animate-fade-up">
        <button onClick={finish} data-testid="tour-close" className="absolute top-3 right-3 text-stone-400 hover:text-stone-700"><X className="w-5 h-5" /></button>
        <div className="text-4xl mb-3">{s.emoji}</div>
        <h3 className="font-serif text-2xl text-stone-900">{s.title}</h3>
        <p className="text-stone-600 mt-2">{s.text}</p>
        <div className="flex items-center gap-1.5 mt-5">
          {STEPS.map((_, k) => <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-stone-900" : "w-1.5 bg-stone-300"}`} />)}
        </div>
        <div className="flex items-center justify-between mt-6">
          <button onClick={finish} data-testid="tour-skip" className="text-sm text-stone-500 hover:text-stone-800">Passer</button>
          <div className="flex gap-2">
            {i > 0 && <Button variant="outline" size="sm" onClick={() => setI(i - 1)} data-testid="tour-prev">Précédent</Button>}
            {!last
              ? <Button size="sm" data-testid="tour-next" onClick={() => setI(i + 1)}>Suivant</Button>
              : <Button size="sm" data-testid="tour-finish" onClick={async () => { const to = s.to; await finish(); nav(to); }}>Terminer</Button>}
          </div>
        </div>
      </div>
    </div>
  );
}
